import React from 'react';
import PropTypes from 'prop-types';
import { FaSpinner } from 'react-icons/fa';

const sizeMap = { sm: 16, md: 24, lg: 40 };

/**
 * LoadingSpinner — three variants:
 *  - default  : centered flex block (inline use)
 *  - overlay  : absolute overlay over nearest `position:relative` parent
 *  - fullScreen: fixed overlay over entire viewport
 */
const LoadingSpinner = ({ message = '', size = 'md', overlay = false, fullScreen = false, className = '' }) => {
  const iconSize = sizeMap[size];

  if (fullScreen) {
    return (
      <>
        <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-30" style={{ zIndex: 9998 }} />
        <div
          className={`tw-fixed tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center ${className}`}
          style={{ zIndex: 9999 }}
        >
          <FaSpinner className="tw-animate-spin tw-text-blue-600" size={iconSize} />
          {message && <p className="tw-text-sm tw-text-slate-600 tw-mt-3">{message}</p>}
        </div>
      </>
    );
  }

  if (overlay) {
    return (
      <div
        className={`tw-absolute tw-inset-0 tw-z-10 tw-bg-white tw-bg-opacity-75 tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-sm tw-gap-2 ${className}`}
      >
        <FaSpinner className="tw-animate-spin tw-text-blue-500" size={iconSize} />
        {message && <span className="tw-text-sm tw-text-slate-500 tw-font-medium">{message}</span>}
      </div>
    );
  }

  return (
    <div className={`tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-py-8 ${className}`}>
      <FaSpinner className="tw-animate-spin tw-text-blue-600" size={iconSize} />
      {message && <p className="tw-text-sm tw-text-slate-600">{message}</p>}
    </div>
  );
};

LoadingSpinner.propTypes = {
  message:    PropTypes.string,
  size:       PropTypes.oneOf(['sm', 'md', 'lg']),
  overlay:    PropTypes.bool,
  fullScreen: PropTypes.bool,
  className:  PropTypes.string,
};

export default LoadingSpinner;
